import api from './api';

class EmailTemplate {

	constructor (Api) {
		this.Api = Api;
	}

	all () {
		return this.Api.get({
			url:  'v1.1/m/email-templates'
		}).then(response => response.emailTemplates);
	}

	get (emailTemplateId) {
		return this.Api.get({
			url:  'v1.1/m/email-templates/'+emailTemplateId
		}).then(response => response.emailTemplate);
	}

	delete (emailTemplateId) {
		return this.Api.delete({
			url:  'v1.1/m/email-templates/'+emailTemplateId
		});
	}

	update (emailTemplateId, emailTemplate) {
		return this.Api.put({
			url:  'v1.1/m/email-templates/'+emailTemplateId,
			body: emailTemplate,
		});
	}

	create (emailTemplate) {
		return this.Api.post({
			url:  'v1.1/m/email-templates',
			body: emailTemplate
		}).then(response => response.emailTemplate);
	}

	publish (emailTemplateId, destination) {
		return this.Api.put({
			url:  'v1.1/m/email-templates/'+emailTemplateId+'/publish',
			body: destination,
		}).then(response => response.emailTemplate);
	}

}

EmailTemplate.$inject = ['Api'];

export default angular.module('service.emailTemplate', [api])
	.service('EmailTemplate', EmailTemplate)
	.name;



// WEBPACK FOOTER //
// ./src/service/emailTemplate.js